import { http } from 'services';

// Personal - schedules
export function getSchedules(query, cbSuccess, cbError) {
  http.get(
    'personal/schedules',
    query,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - schedule by id
export function getScheduleByID(id, query, cbSuccess, cbError) {
  http.get(
    `personal/schedules/${id}`,
    query,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getScheduledDates(query, cbSuccess, cbError) {
  http.get(
    'personal/scheduled-dates',
    query,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getScheduledDateSchedules(query, cbSuccess, cbError) {
  http.get(
    'personal/scheduled-dates/schedules',
    query,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-personal/api-personal-schedules.js